var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 14,
    fill: "#042F36",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 14,
    height: 85,
    fill: "#042F36",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 135,
    height: 85,
    fill: "#05292F",
    stroke: "#0C505A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 107,
    height: 27,
    rx: 3,
    fill: "url(#paint0_linear_1_9)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 28.5,
    width: 106,
    height: 26,
    rx: 2.5,
    stroke: "#0C505A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 63,
    width: 107,
    height: 27,
    rx: 3,
    fill: "url(#paint1_linear_1_9)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 63.5,
    width: 106,
    height: 26,
    rx: 2.5,
    stroke: "#0C505A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 72C70.8333 72 67.2917 70.5417 64.375 67.625C61.4583 64.7083 60 61.1667 60 57C60 52.8333 61.4583 49.2917 64.375 46.375C67.2917 43.4583 70.8333 42 75 42C75.3889 42 75.7708 42.0139 76.1458 42.0417C76.5208 42.0694 76.8889 42.1111 77.25 42.1667C76.1111 42.9722 75.2014 44.0208 74.5208 45.3125C73.8403 46.6042 73.5 48 73.5 49.5C73.5 52 74.375 54.125 76.125 55.875C77.875 57.625 80 58.5 82.5 58.5C84.0278 58.5 85.4306 58.1597 86.7083 57.4792C87.9861 56.7986 89.0278 55.8889 89.8333 54.75C89.8889 55.1111 89.9306 55.4792 89.9583 55.8542C89.9861 56.2292 90 56.6111 90 57C90 61.1667 88.5417 64.7083 85.625 67.625C82.7083 70.5417 79.1667 72 75 72ZM75 68.6667C77.4444 68.6667 79.6389 67.9931 81.5833 66.6458C83.5278 65.2986 84.9444 63.5417 85.8333 61.375C85.2778 61.5139 84.7222 61.625 84.1667 61.7083C83.6111 61.7917 83.0556 61.8333 82.5 61.8333C79.0833 61.8333 76.1736 60.6319 73.7708 58.2292C71.3681 55.8264 70.1667 52.9167 70.1667 49.5C70.1667 48.9444 70.2083 48.3889 70.2917 47.8333C70.375 47.2778 70.4861 46.7222 70.625 46.1667C68.4583 47.0556 66.7014 48.4722 65.3542 50.4167C64.0069 52.3611 63.3333 54.5556 63.3333 57C63.3333 60.2222 64.4722 62.9722 66.75 65.25C69.0278 67.5278 71.7778 68.6667 75 68.6667Z",
    fill: "#28AC47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_9",
    x: 25,
    y: 28,
    width: 115,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_9",
    x: 25,
    y: 63,
    width: 115,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9",
    x1: 29,
    y1: 41.5,
    x2: 136,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#042F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495242,
    stopColor: "#08424C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9",
    x1: 29,
    y1: 76.5,
    x2: 136,
    y2: 76.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#042F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495242,
    stopColor: "#08424C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042F36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDark);
export default __webpack_public_path__ + "static/media/theme-dark.ef32ef5750d249d28ad335a34851cc55.svg";
export { ForwardRef as ReactComponent };